import type { IconData } from '@stacksjs/iconify-core'

export const strawberry: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M6 23.595C6 14.997 10.235 9 24 9s18 5.997 18 14.595C42 33 32 45 24 45S6 33 6 23.595\"/><path d=\"M11.137 12.037c-1.443-2.125-2.451-4.594-3.033-6.25a1.73 1.73 0 0 1 1.337-2.305c2.781-.506 7.941-1.065 11.23.892c1.483.883 2.578 1.865 3.33 2.893c.75-1.028 1.846-2.01 3.328-2.893c3.289-1.957 8.449-1.398 11.23-.892c1.08.196 1.7 1.27 1.337 2.306c-.581 1.655-1.59 4.124-3.033 6.25M19 18v-2m1 20v-2m-6-7v-2m15-7v-2m-1 20v-2m6-7v-2m-10 2v-2\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default strawberry
